import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateFormat'
})
export class DateFormatPipe implements PipeTransform {

  private months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  transform(value: Date, args?: any): string {
    return value.getDay() + '-' + this.months[value.getMonth()] + ' ' + value.getHours() + ':' + value.getMinutes();
  }

}



// WEBPACK FOOTER //
// ./src/app/pipes/date-format.pipe.ts